import React, { FC } from 'react'
import { Link as GatsbyLink } from 'gatsby'
import Button from '@material-ui/core/Button'
// import SvgIcon from '@material-ui/core/SvgIcon'

import StylesModule from 'components/lv1/designButton.module.scss'

export interface DesignButtonProps {
  label: string
  to: string
  design: string
}

// const arrowPath =
//   'M15.3,7.4l-4.4-3.7L11.5,3L17,7.6l-0.6,0.7L11.9,13l-0.6-0.7l3.9-4H0V7.4H15.3z'
interface buttonStyleProps {
  color: 'primary' | 'inherit' | 'secondary' | 'default' | undefined
  variant: 'outlined' | 'text' | 'contained' | undefined
  size: 'large' | 'small' | 'medium' | undefined
  style: string
  icon: {
    visible: boolean
    path?: string
  }
}
function ceateButtonDesignPram(design: string) {
  let buttonStyle: buttonStyleProps = {
    color: 'primary',
    variant: 'outlined',
    size: 'large',
    style: StylesModule.default,
    icon: {
      visible: false,
    },
  }
  switch (design) {
    case 'top-fill':
      buttonStyle = {
        color: 'primary',
        variant: 'contained',
        size: 'large',
        style: StylesModule.topFillRoot,
        icon: {
          visible: false,
        },
      }
      break
    case 'outline':
      buttonStyle = {
        color: 'primary',
        variant: 'outlined',
        size: 'large',
        style: StylesModule.outlineRoot,
        icon: {
          visible: false,
          // path: arrowPath,
        },
      }
      break
    case 'footer-fill':
      buttonStyle = {
        color: 'primary',
        variant: 'contained',
        size: 'large',
        style: StylesModule.footerFillRoot,
        icon: {
          visible: false,
        },
      }
      break
    case 'footer-outline':
      buttonStyle = {
        color: 'primary',
        variant: 'outlined',
        size: 'large',
        style: StylesModule.footerOutlineRoot,
        icon: {
          visible: false,
          // path: arrowPath
        },
      }
      break
    case 'default':
      break
  }
  return buttonStyle
}

const DesignButton: FC<DesignButtonProps> = ({ label, to, design }) => {
  const buttonStyle = ceateButtonDesignPram(design)
  return (
    <span className={StylesModule.designButton}>
      <Button
        color={buttonStyle.color}
        variant={buttonStyle.variant}
        size={buttonStyle.size}
        component={GatsbyLink}
        to={to}
        classes={{
          root: buttonStyle.style,
        }}
      >
        {label}
        {/* {buttonStyle.icon.visible && (
          <SvgIcon color="primary" className={StylesModule.icon}>
            <path d={buttonStyle.icon.path} />
          </SvgIcon>
        )} */}
      </Button>
    </span>
  )
}

export default DesignButton
